import { render, staticRenderFns } from "./stuTrainIndex.vue?vue&type=template&id=0dd1afd1"
import script from "./stuTrainIndex.vue?vue&type=script&lang=js"
export * from "./stuTrainIndex.vue?vue&type=script&lang=js"
import style0 from "./stuTrainIndex.vue?vue&type=style&index=0&id=0dd1afd1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports